module.exports = function () {
    return function (time) {
        if (time !== undefined) {
            const timePartArray = time.split(':');

            let ampm = `<small>AM</small>`,
                formattedTime;

            if (timePartArray[0] >= 12) {
                ampm = `<small>PM</small>`;
            }

            if (timePartArray[0] > 12) {
                timePartArray[0] = timePartArray[0] - 12;
            }

            formattedTime = timePartArray[0] + ':' + timePartArray[1] + ampm;

            return formattedTime;
        }

    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/bws-24-12hr-time.js
 **/